import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  User,
  Search,
  ShoppingCart,
  Heart,
  LogOut,
  List,
  X,
} from "lucide-react";
import "./SearchOverlay.css";

const SearchOverlay = ({ searchOpen, setSearchOpen }) => {
  const navigate = useNavigate();
  const [showSearch, setShowSearch] = useState(false);
  const [animateSearch, setAnimateSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Handle search overlay animation
  useEffect(() => {
    if (searchOpen) {
      setShowSearch(true);
      // Delay adding fade-in class for smooth entry
      setTimeout(() => setAnimateSearch(true), 10);
    } else {
      setAnimateSearch(false);
      const timeout = setTimeout(() => setShowSearch(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [searchOpen]);

  // Handle search submission
  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/shop?search=${encodeURIComponent(searchTerm)}`);
      setSearchOpen(false);
      setSearchTerm("");
    }
  };

  // Close search overlay
  const closeSearch = () => {
    setSearchOpen(false);
    setSearchTerm("");
  };

  // Handle escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && searchOpen) {
        closeSearch();
      }
    };

    if (searchOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [searchOpen]);

  if (!showSearch) return null;

  return (
    <div
      className={`search-overlay ${animateSearch ? "fade-in" : "fade-out"}`}
      onClick={closeSearch}
    >
      <form
        className="search-box"
        onSubmit={handleSearch}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the form
      >
        <input
          type="text"
          placeholder="Search for products..."
          autoFocus
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button type="button" onClick={() => setSearchOpen(false)}>
          <X size={18} strokeWidth={1.5} />
        </button>
        <button type="submit" className="search-submit">
          <Search size={18} strokeWidth={1.5} />
        </button>
      </form>
    </div>
  );
};

export default SearchOverlay;
